import { render, staticRenderFns } from "./HeadInfo.vue?vue&type=template&id=4d866d96&scoped=true&"
import script from "./HeadInfo.vue?vue&type=script&lang=js&"
export * from "./HeadInfo.vue?vue&type=script&lang=js&"
import style0 from "./HeadInfo.vue?vue&type=style&index=0&id=4d866d96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d866d96",
  null
  
)

export default component.exports